import { useClientType } from "../../../shared/hooks/use-client-type";
import { useUserRoles } from "../../../shared/hooks/use-user-roles";

export const ApplicationsPageTitle = () => {
  const clientType = useClientType();
  const roles = useUserRoles();
  const isOperator = (clientType === "external" && roles.isExternalOperator) || (clientType === "internal" && roles.isInternalOperator);

  return <h1 className="text-type-common heading-h4 shrink-0 font-bold leading-8">{isOperator ? "Заявки оператора" : "Заявки"}</h1>;
};
